import AxiosInstance from "./instance";

interface IContactForm {
    first_name: string;
    last_name: string;
    email: string;
    company_name: string;
    country: string;
    subject: string;
    additional_info: string;
};

const sendUserFeedback = async (data: IContactForm) => {
    const response = await AxiosInstance.getInstance().post("/contact-us", data);
    return response;
};

export {sendUserFeedback};


// WEBPACK FOOTER //
// ./src/api/Contact.ts